<template>
    <div class="container" id="resources-vue">
        <div class="mdc-tab-container">
            <div class="mdc-tab-scroller">
                <!-- loop -->
                <a class="mdc-tab tabResources" :class="{active: mdcTab.isActive}"
                   :href="mdcTab.link"
                   :data-term="mdcTab.slug" :data-termid="mdcTab.id"
                   v-for="mdcTab in mdcTabs" :key="mdcTab.id">
                    <span class="mdc-tab-label">
                        <span class="count">{{mdcTab.order + '.'}}</span>
                        {{mdcTab.name}}
                    </span>
                </a>
                <!-- loop end -->
                <!-- search bar -->
                <div class="search-container resourcesserch">
                    <input id="resourcesserch" class="elemserch keyupVal" :placeholder="tr.search"
                           value="" @keyup.13="applyResourceFilter($event)">
                    <span class="s-close" @click="clearResourceFilter"></span>
                    <span class="line"></span>
                </div>
            </div>
        </div>

        <div id="res-tag-container" class="mdc-tag-container">
            <!-- loop: show tags btn -->
            <a class="mdc-tag resTerm" :class="{active: resTag.isActive, 'all-files': (resTag.id === 0)}" :data-id="resTag.id" :data-slug="resTag.slug"
                 :href="resTag.link" @click.prevent="onTagClick(resTag, $event)" v-for="resTag in resTags" :key="resTag.id">
                <span v-if="resTag.id === 0">{{tr.all_files}}</span>
                <span v-else>
                    {{resTag.name}}
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-times-circle fa-w-16"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>
                </span>
            </a>
            <!-- loop end -->
            <a class="mdc-tag resTerm" href="#" v-if="isMultiSelect" @click.prevent="onClearAll"><span>{{tr.clear_all}}</span></a>
        </div>
        <div id="resources-res" class="block-post-res">

            <!-- loop -->
            <div class="col-xl-4 col-md-6 col-12 post-item" v-for="post in displayPosts" :key="post.title">
                <div class="post-item-wrap">

                <div class="wrap-post-image">

                    <a :href="post.link">
                        <div class="post-image"
                             :style="postImageStyle(post.thumbnail)" v-if="post.thumbnail"></div>
                        <div class="post-image"
                             :style="postImageStyle(constLinks.default_post_img)" v-else></div>

                        <div class="download-icon">
                            <img :src='constLinks.ic_video_play' alt="Icon" v-if="post.is_video">
                            <img :src='constLinks.ic_file_download' alt="Icon" v-else>
                        </div>
                    </a>
                </div>

                <div class="post-category">
                    <a class="link-category">
                        {{post.post_type}} |
                    </a>

                    <a class="link-category" href="#" :data-slug="post_tag.slug" v-for="post_tag in post.post_tags" :key="post_tag.slug">
                        {{post_tag.name}}
                    </a>
                </div>
                <div class="post-description">
                    <a :href="post.link">
                        <h3 class="h5 title-post">
                            {{post.title}}
                        </h3>
                    </a>
                    <div class="content-editor">
                        {{post.excerpt}}
                    </div>

                </div>
                </div>
            </div>
            <!-- loop end -->

            <!-- show more btn -->
            <div class="col-12 loadmore_btn_wrap" v-if="showMoreBtn" @click="onClickShowMore">
                <div class="loadmore_btn loadresources">{{tr.show_more}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { mdcTabs,
        resTags,
        posts,
        tr,
        constLinks} from './handler';

    @Component
    export default class ResourceList extends Vue {
        mdcTabs = mdcTabs;
        resTags = resTags;
        allPosts = posts;
        tr = tr;
        constLinks = constLinks;
        selectedTags = [];
        count_per_page = (posts.length > 9) ? 9 : null;
        showMoreBtn = (this.count_per_page > 0);

        get isMultiSelect() {
            return this.selectedTags.length !== 0
        }

        get displayPosts() {
            if (this.selectedTags.length === 0) {
                this.showMoreBtn = (this.allPosts.length > this.count_per_page && this.count_per_page > 0);
                // console.log(this.count_per_page);
                // console.log(this.showMoreBtn);

                if (this.count_per_page)
                    return this.allPosts.slice(0, this.count_per_page);
                else
                    return this.allPosts;
            }
            let tempPosts = [];
            this.allPosts.forEach((_post) => {
                for (let i = 0; i < this.selectedTags.length; i++) {
                    if (_post.post_tags_slug.indexOf(this.selectedTags[i]) !== -1) {
                        tempPosts.push(_post);
                        break;
                    }
                }
            });
            this.showMoreBtn = (this.count_per_page > 0 && tempPosts.length > this.count_per_page);
            // console.log(this.count_per_page);
            // console.log(this.showMoreBtn);
            if (this.count_per_page)
                return tempPosts.slice(0, this.count_per_page);
            else
                return tempPosts;
        }

        postImageStyle(link) {
            return {
                backgroundImage: 'url(\'' + link + '\')'
            }
        }

        onTagClick(_resTag, $event) {
            let $curTarget = $($event.currentTarget);
            $curTarget.toggleClass('active');
            if ($curTarget.hasClass('active')) {
                if (_resTag.id !== 0) {
                    this.selectedTags.push(_resTag.slug);
                    $('.resTerm.all-files').removeClass('active');
                } else {
                    this.selectedTags = [];
                    $('.resTerm').not('.all-files').removeClass('active');
                }
            } else {
                if (_resTag.id !== 0) {
                    // console.log(_resTag.slug);
                    // console.log(this.selectedTags.indexOf(_resTag.slug));
                    this.selectedTags.splice(this.selectedTags.indexOf(_resTag.slug), 1);
                }
            }
            this.count_per_page = (this.allPosts.length > 9) ? 9 : null;
            // console.log(this.selectedTags);
        }

        onClearAll() {
            $('.resTerm').removeClass('active');
            $('.resTerm.all-files').addClass('active');
            this.selectedTags = [];
        }

        onClickShowMore() {
            this.count_per_page = null;
        }

        applyResourceFilter($event) {
            if ($event) {
                let $curTarget = $($event.currentTarget);
                if ($curTarget.val().length === 0){
                    this.s_Close();
                }
            }

            $('.loader').addClass('active');
            $('#offset').val('');
            let query_data = {};
            $('.aj-hid').each( function () {
                if ( $(this).val()){
                    query_data[$(this).attr('name')] = $(this).val();
                }
            });
            if ($('#resourcesserch').val()) {
                query_data['s'] = $("#resourcesserch").val();
            }

            query_data['action'] = 'resource_filter';
            query_data['json'] = true;
            $.ajax({
                url: globalurl + "/wp-admin/admin-ajax.php",
                type: "POST",
                data: query_data
            })
                .done((data) => {
                    data = data || [];
                    this.$nextTick(() => {
                        this.allPosts = data;
                    });
                    $('.loader').removeClass('active');
                }).fail(() => {
                    console.log('error');
                    $('.loader').removeClass('active');
                });
        }

        clearResourceFilter() {
            this.s_Close();
            this.applyResourceFilter();
        }

        s_Close(){
            $('input.elemserch').val('').attr('value',  '').blur();
        }
    }
</script>


// WEBPACK FOOTER //
// App/components/ResourceList/ResourceList.vue